import { typecastRouteProps } from "shared/helpers/routing";

export default [
  {
    component: () => import("pages/OnlineArticleList.vue"),
    meta: {
      title: "Online Articles",
    },
    name: "online-search",
    path: "/articles",
  },
  {
    component: () => import("pages/OnlineArticleBulkSearch.vue"),
    meta: {
      title: "Online Article Bulk Search",
    },
    name: "articles-bulk-search",
    path: "/articles/bulk-search",
  },
  {
    component: () => import("pages/OnlineArticleEdit.vue"),
    meta: {
      title: "New Online Article",
    },
    name: "online-articles-add",
    path: "/articles/new",
    props: { medium: "websites" },
  },
  {
    component: () => import("pages/OnlineArticleEdit.vue"),
    meta: {
      title: "Edit Online Article",
    },
    name: "online-articles-edit",
    path: "/articles/:id",
    props: true,
  },
  {
    component: () => import("pages/WebsiteList.vue"),
    meta: {
      title: "Websites",
    },
    name: "websites-index",
    path: "/websites",
    props: (route) => typecastRouteProps(route),
  },
  {
    component: () => import("pages/WebsiteEdit.vue"),
    meta: {
      title: "New Website",
    },
    name: "websites-new",
    path: "/websites/new",
  },
  {
    component: () => import("pages/WebsiteEdit.vue"),
    meta: {
      title: "Edit Website",
    },
    name: "websites-edit",
    path: "/websites/:id/edit",
    props: true,
  },
  {
    component: () => import("pages/WebsiteEventsList.vue"),
    meta: {
      title: "Websites Scraper Logs",
    },
    name: "websites-scraper-logs",
    path: "/websites/scraper-logs",
    props: (route) => typecastRouteProps(route),
  },
  {
    component: () => import("pages/BlocklistUrlPatternList.vue"),
    meta: {
      title: "Blocklist URL Patterns",
    },
    name: "blocklist-url-patterns-index",
    path: "/blocklist-url-patterns",
  },
  {
    component: () => import("pages/BlocklistUrlPatternEdit.vue"),
    meta: {
      title: "New Blocklist URL Pattern",
    },
    name: "blocklist-url-patterns-new",
    path: "/blocklist-url-patterns/new",
  },
  {
    component: () => import("pages/BlocklistUrlPatternEdit.vue"),
    meta: {
      title: "Edit Blocklist URL Pattern",
    },
    name: "blocklist-url-patterns-edit",
    path: "/blocklist-url-patterns/:id/edit",
    props: (route) => typecastRouteProps(route),
  },
];
